import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  background: css`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -550px;

    svg {
      width: 100%;
      height: 100%;
    }
  `,
  backgroundClosed: css`
    width: 760px;
    height: 730px;
  `,
  backgroundOpen: css`
    bottom: -400px;
    width: 1162px;
    height: 1116px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
